var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTimeSpeed = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 159 122",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m81.559 47.368 16.615 16.556L124.76 40.74",
  stroke: "url(#time-speed_svg__a)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M98.174 7.628v9.928",
  stroke: "url(#time-speed_svg__b)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M98.174 113.611v-9.937",
  stroke: "url(#time-speed_svg__c)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M151.358 60.615h-9.972",
  stroke: "url(#time-speed_svg__d)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.786 60.615H48.32",
  stroke: "url(#time-speed_svg__e)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.08 40.74h46.533",
  stroke: "url(#time-speed_svg__f)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.401 77.171h43.212",
  stroke: "url(#time-speed_svg__g)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M46.222 31.027C56.537 13.09 75.942 1 98.173 1 131.215 1 158 27.69 158 60.615c0 32.924-26.785 59.615-59.827 59.615-23.311 0-43.508-13.292-53.382-32.673",
  stroke: "url(#time-speed_svg__h)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "time-speed_svg__a",
  x1: 38.07,
  y1: 63.607,
  x2: 157.593,
  y2: 63.607,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "time-speed_svg__b",
  x1: 58.434,
  y1: 12.592,
  x2: 137.934,
  y2: 12.592,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "time-speed_svg__c",
  x1: 56.934,
  y1: 108.642,
  x2: 137.934,
  y2: 108.642,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "time-speed_svg__d",
  x1: 38.071,
  y1: 61.115,
  x2: 156.882,
  y2: 61.115,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "time-speed_svg__e",
  x1: 38.07,
  y1: 61.115,
  x2: 159.016,
  y2: 61.115,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "time-speed_svg__f",
  x1: 33.801,
  y1: 41.24,
  x2: 156.882,
  y2: 41.24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "time-speed_svg__g",
  x1: 33.801,
  y1: 77.671,
  x2: 158.305,
  y2: 77.671,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "time-speed_svg__h",
  x1: 38.07,
  y1: 60.615,
  x2: 158,
  y2: 60.615,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})))));
export { SvgTimeSpeed as ReactComponent };
export default __webpack_public_path__ + "/assets/d9611612700648df08e44f05651c4d67.svg";